import {PageContainer, PageTitle} from '@hconnect/uikit/src/lib2'
import {Box} from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import {useMemo} from 'react'
import {useTranslation} from 'react-i18next'

import {SubscriptionButton} from '../../shared/components/SubscriptionButton'
import {UserSignalGroupsConfig} from '../../shared/types/sensor.types'
import {usePlantMonitoring} from '../context/PlantMonitoringContext'

import {ControlPanel} from './ControlPanel'
import {SignalCharts} from './SignalCharts'
import {SignalTreeContainer} from './SignalTree/SignalTree'

export const PM = () => {
  const {t} = useTranslation()
  const {state} = usePlantMonitoring()

  const groupsConfig: UserSignalGroupsConfig = useMemo(
    () => ({
      disableEdit: false,
      predefinedGroups: [],
      masterUpmId: null
    }),
    []
  )

  const signalTreeGridConfig = state.uiLayout.signalTreeCollapsed
    ? ({
        xs: 12,
        md: 12,
        lg: 'auto'
      } as const)
    : ({
        xs: 12,
        md: 12,
        lg: 5,
        xl: 4
      } as const)

  return (
    <>
      <Box
        display="flex"
        justifyContent="space-between"
        gap={1}
        alignItems={{xs: 'stretch', md: 'flex-start'}}
        flexDirection={{xs: 'column', sm: 'row'}}
      >
        <PageTitle
          mb={0}
          pt={0.5}
          data-test-id="kms-page-title"
          maxWidth="fit-content"
          display={{xs: 'none', md: 'block'}}
        >
          {t('general.pmTitle')}
        </PageTitle>
        <SubscriptionButton />
        <ControlPanel />
      </Box>
      <Grid container spacing={2} mt={2}>
        <Grid {...signalTreeGridConfig}>
          <SignalTreeContainer groupsConfig={groupsConfig} />
        </Grid>
        <Grid xs={true}>
          <SignalCharts disableGroupEdit={groupsConfig.disableEdit} />
        </Grid>
      </Grid>
    </>
  )
}

export const PMContainer = () => {
  return (
    <PageContainer display="flex" flexDirection="column" bgcolor="#01407F" flexGrow={1}>
      <PM />
    </PageContainer>
  )
}
